import { ViewModel, View, ObservableArray } from "binder"
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { ServerConnection } from "src/server/serverConnection";
import { downloadFile, getAsNumber } from "src/uicomponents/components/utilities";
import { PaginationInfo, ServerSideDataLoader } from "uicomponents";
import { WarehouseSelector } from "../../rawData/warehouse/warehouseSelector";
import { SetInitialBalanceView } from "./setInitialBalance-view"
import { FileChooser, translate } from "src/common/utilities";

export class SetInitialBalanceViewModel extends WindowViewModel {
    public getTitle(): string {
        return translate("setInitialBalance-viewModel.adjustmentInventory", {});
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);

        this.lineItems = ObservableArray.create<lineItem>();
        this.loader = new ServerSideDataLoader(filteringInformation => this.refreshPaged(filteringInformation), 30);
        this.warehouseSelector = new WarehouseSelector(this);
        this.canUploadExcelFile = false;
        this.warehouseSelector.onSelectionChanged = w => {
            this.updateExcelUploderStatus();
            this.lineItems.clear();
            this.refresh();
        }
    }
    GetDefaultView(): View<ViewModel> {
        return new SetInitialBalanceView();
    }
    public getTypeId(): string {
        return "VM-750A4245-D44B-48D3-86F2-7C9EF6E9846E"
    }

    public set warehouseSelector(v: WarehouseSelector) { this._warehouseSelector = v; } public get warehouseSelector(): WarehouseSelector { return this._warehouseSelector; } private _warehouseSelector: WarehouseSelector;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader; } private _loader: ServerSideDataLoader;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set lineItems(v: ObservableArray<lineItem>) { this._lineItems = v; } public get lineItems(): ObservableArray<lineItem> { return this._lineItems; } private _lineItems: ObservableArray<lineItem>;
    public set canUploadExcelFile(v: boolean) { this._canUploadExcelFile = v; } public get canUploadExcelFile(): boolean { return this._canUploadExcelFile; } private _canUploadExcelFile: boolean;

    updateExcelUploderStatus() {
        if (this.warehouseSelector.selectedItem != null) {
            this.canUploadExcelFile = true;
        } else {
            this.canUploadExcelFile = false;
        }
    }

    async refresh() {
        await this.loader.refresh();
    }
    async refreshPaged(filteringInformation: any): Promise<PaginationInfo> {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/InventoryServices/ListAllProductsWithTheirReorderPoint', {
                FurtherQueryInfo: filteringInformation,
                WarehouseId: this.warehouseSelector.selectedItem?.id
            });
            this.lineItems.update(...result.Products.map(q => {
                let r = new lineItem(this);
                r.measuredProductId = q.MeasuredProductId;
                r.productName = q.ProductName;
                r.productCode = q.ProductCode;
                r.unitName = q.UnitName;
                r.balance = q.Balance;
                r.availableBalance = q.AccessibleBalance;
                r.newBalance = q.Balance;
                r.newAccessibleBalance = q.AccessibleBalance;
                r.isEdited = false;
                return r;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage, result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0, 0);
        } finally {
            this.isLoading = false;
        }
    }
    async save(item: lineItem) {
        try {
            this.isLoading = true;
            await ServerConnection.callServer('/Complex/InventoryServices/SetWarehouseInitialBalance', {
                Balances: [{
                    WarehouseId: this.warehouseSelector.selectedItem?.id,
                    MeasuredProductId: item.measuredProductId,
                    Balance: item.newBalance,
                    AvailableBalance: item.newBalance
                }]
            });
        } catch (ex) {
            throw ex;
        } finally {
            this.isLoading = false;
        }
    }

    async downloadExcelTemplate() {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/InventoryServices/DownloadExcelTemplateForSetWarehouseInitialBalances', {
                WarehouseId: this.warehouseSelector.selectedItem?.id
            });
            downloadFile(result.ExcelFile, "SetWarehouseInitialBalance.xlsx");
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    async uploadExcelFile() {
        let fileChooser = new FileChooser();
        let choosedFile = await fileChooser.chooseFile();
        if (choosedFile.isChoosed == false) {
            return;
        }
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/InventoryServices/UploadWarehouseInitialBalancesFromExcelFile', {
                ExcelFile: choosedFile.fileContent,
                WarehouseId: this.warehouseSelector.selectedItem?.id
            });

            if (result.IsSuccessful == false) {
                return
            }

            if (result.IsValidFile == false) {
                downloadFile(result.ExcelFile, "SetWarehouseInitialBalance.xlsx");
                await this.messageBoxConfirmWarning("تعداد از اطلاعات وارد شده نادرست می باشد.", "تنظیم موجودی اولیه");
                return;
            }

            await this.messageBoxConfirmSuccess("اطلاعات با موفقیت وارد شد.", "تنظیم موجودی اولیه");
            this.refresh();

        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
}

export class lineItem extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: SetInitialBalanceViewModel) {
        super(parent);
        this.typedParent = parent;
    }
    private typedParent: SetInitialBalanceViewModel;
    public set measuredProductId(v: string) { this._measuredProductId = v; } public get measuredProductId(): string { return this._measuredProductId; } private _measuredProductId: string;
    public set productName(v: string) { this._productName = v; } public get productName(): string { return this._productName; } private _productName: string;
    public set productCode(v: string) { this._productCode = v; } public get productCode(): string { return this._productCode; } private _productCode: string;
    public set unitName(v: string) { this._unitName = v; } public get unitName(): string { return this._unitName; } private _unitName: string;
    public set balance(v: number) { this._balance = v; } public get balance(): number { return this._balance; } private _balance: number;
    public set availableBalance(v: number) { this._availableBalance = v; } public get availableBalance(): number { return this._availableBalance; } private _availableBalance: number;
    public set newBalance(v: number) {
        this._newBalance = getAsNumber(v, true);
        this.isEdited = true;
    } public get newBalance(): number { return this._newBalance; } private _newBalance: number;

    public set newAccessibleBalance(v: number) {
        this._newAccessibleBalance = getAsNumber(v, true);
        this.isEdited = true;;
    } public get newAccessibleBalance(): number { return this._newAccessibleBalance; } private _newAccessibleBalance: number;

    public set isEdited(v: boolean) { this._isEdited = v; } public get isEdited(): boolean { return this._isEdited; } private _isEdited: boolean;

    async confirm() {
        let confirmation = '';
        confirmation = await this.messageBoxWarningYesNo(translate("setInitialBalance-viewModel.adjustedAmountOfInventory", {}), translate("setInitialBalance-viewModel.adjustmentInventory", {}));
        if (confirmation == 'no') {
            return;
        }
        try {
            await this.typedParent.save(this);
            this.balance = this.newBalance;
            this.availableBalance = this.newAccessibleBalance;
            this.isEdited = false;
            await this.messageBoxConfirmSuccess(translate("setInitialBalance-viewModel.successfullyRegistered", {}), translate("setInitialBalance-viewModel.adjustmentInventory", {}));
        } catch (ex) {
            console.log(ex);
        } finally {
        }
    }
}